import type { IconSvgObject } from './types';

const RadiusIcon: IconSvgObject = [
  ["path", { d: "M12 13.5C11.1716 13.5 10.5 12.8284 10.5 12C10.5 11.1716 11.1716 10.5 12 10.5C12.8284 10.5 13.5 11.1716 13.5 12C13.5 12.8284 12.8284 13.5 12 13.5Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19.0007 12H14M19.0007 12C19.0007 11.4398 16.9999 10 16.9999 10M19.0007 12C19.0007 12.5602 16.9999 14 16.9999 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default RadiusIcon;
